<template>
  <img :src=getIcon(line) />
</template>

<script>
import walk from "../../assets/images/icon-walking.svg"
import airplane from "../../assets/images/icon-plane.svg"
import bus from "../../assets/images/icon-bus.svg"
import train from "../../assets/images/icon-train.svg"
import car from "../../assets/images/icon-taxi.svg"
import ship from "../../assets/images/icon-ship.svg"

export default {
  props: {
    line: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  methods: {
    getIcon: function (line) {
      switch (this.getTextValue(line.type)) {
      case "walk":
        return walk;
      case "plane":
        return airplane;
      case "bus":
        return bus;
      case "ship":
        return ship;
      case "car":
        return car;
      default:
        return train;
      }
    },
    getTextValue: function (obj) {
      return (obj === undefined ? "" : (obj.text !== undefined ? obj.text : obj));
    }
  }
}
</script>
